import { combineReducers } from "redux";

import alerts from "./alerts";
import blogs from "./blogs";
import cart from "./cart";
import categories from "./categories";
import coupons from "./coupons";
import faqs from "./faqs";
import itSupport from "./itSupport";
import nurses from "./nurses";
import order from "./order";
import orders from "./orders";
import products from "./products";
import resources from "./resources";
import senior from './senior';
import seniorHomes from "./senior_homes";
import services from "./services";
import shippingMethods from "./shipping";
import user from "./user";
import users from "./users";
import videoMeet from "./videoMeet";
import headNurse from './headNurse';
import subscription from './subscription';
import region from './region';

const rootReducer = () =>
    combineReducers({
        user,
        users,
        cart,
        services,
        alerts,
        coupons,
        blogs,
        resources,
        order,
        orders,
        seniorHomes,
        nurses,
        itSupport,
        videoMeet,
        products,
        categories,
        shippingMethods,
        faqs,
        senior,
        headNurse,
        subscription,
        region,
    });

export default rootReducer;
